import axios from '@/apis/axios-client';

const OnboardingComplete = async () => {
  let url = `/api/onboarding/complete`;
  return await axios.client
    .post(
      url,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log('onboarding: ' + error);
      return error;
    });
};

const OnboardingApi = {
  OnboardingComplete: OnboardingComplete,
};

export default OnboardingApi;
